import React, { useState } from 'react'
import { withRouter } from 'react-router'
import clsx from 'clsx'
import { makeStyles } from '@material-ui/core/styles'
import CssBaseline from '@material-ui/core/CssBaseline'
import { connect } from 'react-redux'


const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
  },
  content: {
    flexGrow: 1,
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  contentShift: {
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: 0,
  },
}))

function MenuWithoutLogin(props) {
  const { children, session } = props
  const classes = useStyles()
  const [open, setOpen] = useState(true)
  const token = localStorage.getItem('token');
  const handleDrawerOpen = () => {
    setOpen(true)
  }
  
  const handleDrawerClose = () => {
    setOpen(false)
  }
  return (
    <div className={classes.root}>
      <CssBaseline />
      <main
        className={clsx(classes.content, {
          [classes.contentShift]: open,
        })}
      >
        { children }
      </main>
    </div>
  )
}

const mapStateToProps = state => ({
  // loading: state.loader.loading,
  session: state.session,
})

export default connect(
  mapStateToProps,
  null,
)(withRouter(MenuWithoutLogin))